export default function (imageUrl) {
  return imageUrl && (imageUrl.includes('data:') || imageUrl.startsWith('/'));
}
